import { Directive, HostListener, ElementRef, Input } from '@angular/core';
@Directive({
  selector: '[numberAmount]'
})
export class onlynumberSpecialCharacter {
  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const inputElement = this._el.nativeElement as HTMLInputElement;
    const initialValue = inputElement.value;

    // Regex to allow numbers and one decimal point
    inputElement.value = initialValue.replace(/[^0-9.]/g, ''); // Remove non-numeric and non-dot characters

    // Prevent multiple decimal points
    const parts = inputElement.value.split('.');
    if (parts.length > 2) {
      inputElement.value = parts[0] + '.' + parts[1];
    }

    // Optional: Limit to 2 decimal places
    if (parts[1]?.length > 2) {
      inputElement.value = parts[0] + '.' + parts[1].substring(0, 2);
    }

    // If value changed, stop propagation
    if (initialValue !== inputElement.value) {
      event.stopPropagation();
    }
  }

}